<template>
  <div>
    <tabs class="versions-tabs" ref="tab-sections" :value="(GrantForm.isOnARevisionTab ? $t('medium_grant.revision_tab__revised_version') : $t('medium_grant.revision_tab__original_version'))" @activate-tab="activateTab" type="info" square>
      <tab-pane id="original" :label="$t('medium_grant.revision_tab__original_version')">
        <grant-sub-wizard>
          <grant-sub-wizard-tab :before-change="() => validateStep('step1')">
            <page1 ref="step1"></page1>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step2')">
            <page2 ref="step2"></page2>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step3')">
            <page3 ref="step3"></page3>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step4')">
            <page4 ref="step4"></page4>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step5')">
            <page5 ref="step5"></page5>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step6')">
            <page6 ref="step6"></page6>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step7')">
            <page7 ref="step7"></page7>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step8')">
            <page8 ref="step8"></page8>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step9')">
            <page9 ref="step9"></page9>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('step10')">
            <page10 ref="step10"></page10>
          </grant-sub-wizard-tab>
        </grant-sub-wizard>
      </tab-pane>
      <tab-pane id="revised" :label="$t('medium_grant.revision_tab__revised_version')" v-if="GrantForm.hasRevision">
        <grant-sub-wizard>
          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step1')">
            <revised-page1 ref="revised-step1"></revised-page1>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step2')">
            <revised-page2 ref="revised-step2"></revised-page2>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step3')">
            <revised-page3 ref="revised-step3"></revised-page3>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step4')">
            <revised-page4 ref="revised-step4"></revised-page4>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step5')">
            <revised-page5 ref="revised-step5"></revised-page5>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step6')">
            <revised-page6 ref="revised-step6"></revised-page6>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step7')">
            <revised-page7 ref="revised-step7"></revised-page7>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step8')">
            <revised-page8 ref="revised-step8"></revised-page8>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step9')">
            <revised-page9 ref="revised-step9"></revised-page9>
          </grant-sub-wizard-tab>

          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step10')">
            <revised-page10 ref="revised-step10"></revised-page10>
          </grant-sub-wizard-tab>
        </grant-sub-wizard>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import Page2 from './Page2';
  import Page3 from './Page3';
  import Page4 from './Page4';
  import Page5 from './Page5';
  import Page6 from './Page6';
  import Page7 from './Page7';
  import Page8 from './Page8';
  import Page9 from './Page9';
  import Page10 from './Page10';

  import RevisedPage1 from './Revised/Page1';
  import RevisedPage2 from './Revised/Page2';
  import RevisedPage3 from './Revised/Page3';
  import RevisedPage4 from './Revised/Page4';
  import RevisedPage5 from './Revised/Page5';
  import RevisedPage6 from './Revised/Page6';
  import RevisedPage7 from './Revised/Page7';
  import RevisedPage8 from './Revised/Page8';
  import RevisedPage9 from './Revised/Page9';
  import RevisedPage10 from './Revised/Page10';

  import {TabPane, Tabs} from 'src/components';
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      Tabs,
      TabPane,
      GrantForm,
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
      Page2,
      Page3,
      Page4,
      Page5,
      Page6,
      Page7,
      Page8,
      Page9,
      Page10,
      RevisedPage1,
      RevisedPage2,
      RevisedPage3,
      RevisedPage4,
      RevisedPage5,
      RevisedPage6,
      RevisedPage7,
      RevisedPage8,
      RevisedPage9,
      RevisedPage10,
    },
    methods: {
      activateTab(ev) {
        GrantForm.isOnARevisionTab = (ev.id === 'revised');
      },
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>
